import { useQueryClient } from '@tanstack/react-query'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import RefreshIcon from '@mui/icons-material/Refresh'

export default function RefreshButton() {
    const queryClient = useQueryClient()
    return (
        <Tooltip
            title='تحديث'
            placement='right'
        >
            <IconButton
                sx={{
                    position: 'fixed',
                    bottom: 15,
                    insetInlineEnd: 15,
                    zIndex: 1
                }}
                onClick={() => queryClient.invalidateQueries({ queryKey: ['quick-look'] })}
            >
                <RefreshIcon />
            </IconButton>
        </Tooltip>
    )
}